import service from '../api/account.service';
//constants
const data = {
    accounts: [],
    accountAdd: null,
    responseAccount: null,
    noPermittedAccount: ''
}
//types
const LIST_ACCOUNT = 'LIST_ACCOUNT';
const LIST_ACCOUNT_ERROR = 'LIST_ACCOUNT_ERROR';
const ADD_ACCOUNT = 'ADD_ACCOUNT';
const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
const DELETE_ACCOUNT = 'DELETE_ACCOUNT';

//reducer
export default function accountReducer(state = data, action) {
    switch (action.type) {
        case LIST_ACCOUNT:
            return { ...state, accounts: action.payload };
        case ADD_ACCOUNT:
            return { ...state, accountAdd: action.payload };
        case LIST_ACCOUNT_ERROR:
            return { ...state, noPermittedAccount: action.payload };
        default:
            return { ...state };
    }
}

export const findAccounts = (user,entity) => async (dispatch) => {
    
    const response = await service.getAccounts(user,0,entity).then((r) => { return r.data });
    let data = [];


    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.id,
                    label: element.account
                });
            });
        } else {
            dispatch({
                type: LIST_ACCOUNT_ERROR,
                payload: response.message
            });
        }
    }
    dispatch({
        type: LIST_ACCOUNT,
        payload: data
    });
}

export const findRawAccounts= (user,entity) => async (dispatch) => {
    const response = await service.getAccounts(user,1,entity).then((r) => { return r.data });

    dispatch({
        type: LIST_ACCOUNT,
        payload: response
    });
    return response;
}

export const saveAccount = (accountData) => async (dispatch) => {
    const response = await service.saveAccount(accountData).then((r) => { return r.data });
    dispatch({
        type: ADD_ACCOUNT,
        payload: response
    });
    return response;
}
export const updateAccount  = (accountData) => async (dispatch) => {
    const response = await service.updateAccount(accountData).then((r) => { return r.data });

    dispatch({
        type: UPDATE_ACCOUNT,
        payload: response
    });
    return response;
}

export const deleteAccount = (accountData) => async (dispatch) => {
    const response = await service.deleteAccount(accountData).then((r) => { return r.data });

    dispatch({
        type: DELETE_ACCOUNT,
        payload: response
    });
    return response;
}